import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { ciisKodRegExp } from 'enums/regExp';

export const giinKodValidation = () => [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || ciisKodRegExp.test(value)) return Promise.resolve();
            if (value && !ciisKodRegExp.test(value)) return Promise.reject(<TranslateText>GIIN_INVALID</TranslateText>);
            return Promise.resolve();
        }
    })
];

export default giinKodValidation;
